// Mounts the deliverable drawers from the URL on every program page (see
// drawerParams). One drawer shows at a time, top-most first: Record review
// over its date, the submit drawer over its date, then the date itself.
// Closing the top one reveals the one beneath, because its param is still set.
import { jsx as _jsx } from "react/jsx-runtime";
import { useCmDrawerParams } from '../drawerParams';
import { AssignmentDrawer } from './AssignmentDrawer';
import { OccurrenceDrawer } from './OccurrenceDrawer';
import { RecordReviewDrawer } from './RecordReviewDrawer';
import { SubmitDrawer } from './SubmitDrawer';
export function CmDrawers({ programId }) {
    const p = useCmDrawerParams();
    if (!programId) return null;
    if (p.review && p.occ) return /*#__PURE__*/ _jsx(RecordReviewDrawer, {
        programId: programId,
        occId: p.occ,
        submissionId: p.review
    }, p.review);
    if (p.submit) return /*#__PURE__*/ _jsx(SubmitDrawer, {
        programId: programId,
        target: p.submit
    }, p.submit);
    if (p.assign) return /*#__PURE__*/ _jsx(AssignmentDrawer, {
        programId: programId,
        target: p.assign
    }, p.assign);
    if (p.occ) return /*#__PURE__*/ _jsx(OccurrenceDrawer, {
        programId: programId,
        occId: p.occ
    }, p.occ);
    return null;
}
